import i18n from "@/i18n";
import { DeclarationPropertyData } from "../../data/declarationPropertyData";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { ContractData } from "../../data/contractData";
import { ContractsFilters } from "../../data/enums/contractsFilters";
import { ContractsTypes } from "../../data/enums/contractsTypes";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { DeclarationPropertiesViews } from "../../data/enums/declarationPropertiesViews";
import { CardModel } from "../../models/contracts/cardModel";
import { CardsStates } from "../../data/enums/cardsStates";
import currencyFilter from "../../filters/currency.filter";
import sumFilter from "../../filters/sum.filter";
import { ContractModel } from "../contracts/contractModel";
import { ContractsModel } from "../contracts/contractsModel";
import urlFilter from "../../filters/url.filter";
import router from "@/router";
import { ConfigStore } from "../../store/modules/config";
import { appConfig } from "../../config/index";
import { replaceByTemplate } from "../../utilities/index";
import { PhoneFormat } from "../../data/phoneFormat";

/** Модель реквизита операции. */
export class OperationPropertyModel {

  /**Данные декларации. */
  public Declaration: DeclarationPropertyData;
  /**
   * Коллекция списка значений.
   */
  public Values: Array<DeclarationPropertyValueData> = [];

  public SubProperties: Array<OperationPropertyModel> = [];

  /**Текущее значение */
  public _value: any = "";

  /**Символ валюты для суммы */
  public CurrensySymbol: string = "";

  /**признак ожидания выполнения assign поля */
  public AssignLoading: boolean = false;

  /** Ошбика приходящая с сервера */
  public errorText: string = '';

  public MySelfTransferOperationId: string = '';

  private ToCardOperationId: string = '';

  public isSubProp: boolean = false;

  public parentName: string = '';

  public objectActiveIndex: number | null = null;

  public IsPhone: boolean = false;

  public PhoneRightValue: string = "";

  public PhoneDisplayValue: string = "";

  public SelectedPhoneFormat: PhoneFormat = new PhoneFormat();

  public PhoneFormats: PhoneFormat[] = [];

  public RawPhoneFormats: any = {};

  /**Геттер значения */
  get Value() {
    return this._value;
  }

  /**Сеттер значения */
  set Value(value: any) {
    if (this.IsSum) {
      const floatVal = parseFloat(value);
      this._sumValue =
        isNaN(floatVal) || value == 0
          ? ""
          : sumFilter(value, false, this.CurrensySymbol);
    }
    this._value = value;
  }

  /**Значение для полей с суммой */
  public _sumValue: any = "";
  /**Геттер форматированного значения */
  get SumValue() {
    return this._sumValue;
  }

  /**Сеттер значения на форме */
  set SumValue(value: any) {
    this._sumValue = value;
    this._value = sumFilter(value);
  }

  /**Признак суммы */
  get IsSum() {
    return (
      this.Declaration.Type === DeclarationPropertiesTypes.Decimal &&
      this.Declaration.Size == 2
    );
  }

  /**Признак списка */
  get IsList() {
    return this.Declaration.ListType.trim() !== "";
  }

  /**Правила проверки поля */
  public CheckRules: any = [];

  public Mask: string = "";

  /**Видимость на подтверждении. */
  public ConfirmView: DeclarationPropertiesViews =
    DeclarationPropertiesViews.Editable;

  /**Значение отображения в окне подтверждения */
  get DisplayValue(): string {
    let sValue: string = "";
    if (
      this.Declaration.ListType.trim() !== "" && this.Declaration.Type != DeclarationPropertiesTypes.CardSelector ||
      this.Declaration.Type === DeclarationPropertiesTypes.UserAccount
    ) {
      const selectedValue = this.Value as DeclarationPropertyValueData;
      sValue = selectedValue ? selectedValue.Value : "";
    } else if (this.Declaration.Type === DeclarationPropertiesTypes.ObjectsList) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(this.Value, "text/xml");
      const objects = xmlDoc.getElementsByTagName("object");
      let res: string = '';
      for (let i = 0; i < objects.length; i++) {
        const props = objects[i].getElementsByTagName('properties')[0].getElementsByTagName('property');
        for (let j = 0; j < props.length; j++) {
          const prop = props[j];
          const propTemp = this.SubProperties.find((sProp: any) => sProp.Declaration.Name == prop.getAttribute('name'));
          let propValue: string = prop.getAttribute('value');
          if (propTemp.Declaration.ListType !== '')
            propValue = propTemp.Values.find((val: DeclarationPropertyValueData) => val.Key == propValue)?.Value;
          if (propTemp.Declaration.Type != DeclarationPropertiesTypes.File) {
            res += `${propTemp.Declaration.Caption}: ${!propValue ? 'Не заполнено' : propValue}${j < props.length - 1 ? ',' : '.\n'} `;
          } else {
            res += `${propTemp.Declaration.Caption}: ${!propValue ? 'Не заполнено' : propValue.split('\\').pop()}${j < props.length - 1 ? ',' : '.\n'} `;
          }
        }
      }
      sValue = res;
    } else if (this.Declaration.Type == DeclarationPropertiesTypes.File) {
      sValue = this.Value.split('\\').pop();
    } else if (this.Declaration.Type == DeclarationPropertiesTypes.Decimal && this.Declaration.Size !== null) {
      sValue = parseFloat(this.Value.replace(',', '.')).toFixed(this.Declaration.Size);
    } else if (this.IsSum) {
      sValue = sumFilter(this.Value, false, this.CurrensySymbol);
    } else if (typeof this.Value === "boolean") {
      sValue = this.Value
        ? i18n.t("main.operation.common.yes").toString()
        : i18n.t("main.operation.common.no").toString();
    } else {
      sValue = this.Value;
    }
    return sValue;
  }

  /**Список вариантов значений. */
  constructor(Declaration: DeclarationPropertyData, configStore: ConfigStore | null = null) {
    this.Declaration = Declaration;
    this.MySelfTransferOperationId = configStore?.apiData.OperationCodeOfToContract ?? null;
    this.ToCardOperationId = configStore?.apiData.OperationCodeOfToOtherContractByCard ?? null;
    this.Declaration.SubProperties.forEach((prop: any) => {
      const sopm: OperationPropertyModel = new OperationPropertyModel(prop, configStore);
      sopm.loadValues();
      sopm.loadMasks();
      sopm.loadCheckRules();
      sopm.setAsSubProp();
      sopm.parentName = this.Declaration.Name;
      this.SubProperties.push(sopm);
    });
  }

  public sumFormat() {
    this.Value = sumFilter(this.Value);
  }

  public clearEmtrySum() {
    if (this.Declaration.View === 1 && parseFloat(this._sumValue) == 0) {
      this._sumValue = "";
    }
  }

  /**Название компоненты реквизита */
  get componentName(): string {
    let name = "TextProperty";
    const type: DeclarationPropertiesTypes = this.Declaration.Type;
    const isList: boolean = this.IsList;

    if (type == DeclarationPropertiesTypes.Boolean) {
      name = "SwitchProperty";
    } else if (type == DeclarationPropertiesTypes.Action) {
      name = "ButtonProperty";
    } else if (type == DeclarationPropertiesTypes.UserAccount) {
      name = "UserAccountProperty";
    } else if (type == DeclarationPropertiesTypes.CardSelector) {
      name = "CardSelectProperty";
    } else if (type == DeclarationPropertiesTypes.BankBik) {
      name = "BankBikProperty";
    } else if (isList) {
      name = "ListProperty";
    } else if (type == DeclarationPropertiesTypes.DateTime) {
      name = "DateTimeProperty";
    } else if (
      type == DeclarationPropertiesTypes.String ||
      type == DeclarationPropertiesTypes.Decimal
    ) {
      name = "TextProperty";
    } else if (type == DeclarationPropertiesTypes.ObjectsList) {
      name = "ObjectListProperty";
    } else if (type == DeclarationPropertiesTypes.File) {
      name = "FileTypeProperty";
    }
    return name;
  }

  /**Загрузка масок */
  public loadMasks() {
    this.Mask = this.Declaration.Mask.replace(/[9]/g, "#");
    this.Mask = this.Mask.replace(/[?]/g, "");
  }

  public setAsSubProp(): void {
    this.isSubProp = true;
  }

  /**Загрузка проверок поля */
  public loadCheckRules() {
    const rules = [];

    if (this.Declaration.Type == DeclarationPropertiesTypes.Action) return;

    rules.push(() => {
      return this.Declaration.View != 0 || this.errorText.length <= 0 || this.errorText;
    });

    if (this.Declaration.Required) {
      if (this.Declaration.Type == DeclarationPropertiesTypes.UserAccount || (this.Declaration.ListType.trim() !== '' && this.Declaration.Type != DeclarationPropertiesTypes.CardSelector)) {
        rules.push(
          () =>
            this.Declaration.View != 0 ||
            (this.Value !== null && this.Value.length != 0) ||
            i18n.t("main.operation.errors.rquiredField", {
              name: this.Declaration.Caption,
              msg: this.Declaration.CheckMsg
            })
        );
      } else if (this.Declaration.Type == DeclarationPropertiesTypes.Decimal) {
        rules.push(() => {
          let fVal = parseFloat(this.SumValue?.replace(",", "."));
          if (isNaN(fVal)) {
            fVal = parseFloat(this.Value?.replace(",", "."));
          }
          return (
            this.Declaration.View != 0 ||
            (!isNaN(fVal) && fVal > 0) ||
            i18n.t("main.operation.errors.decimalField", {
              name: this.Declaration.Caption
            })
          );
        });
      } else if (this.Declaration.Type == DeclarationPropertiesTypes.String) {
        if(!this.IsPhone)
        rules.push(
          () =>
            this.Declaration.View != 0 ||
            (this.Value && (this.Value as string).trim() !== "") ||
            i18n.t("main.operation.errors.rquiredField", {
              name: this.Declaration.Caption,
              msg: this.Declaration.CheckMsg
            })
        );
      } else if (this.Declaration.Type == DeclarationPropertiesTypes.DateTime) {
        rules.push(
          () => {
            return this.Declaration.View != 0 ||
              (this.Value && (this.Value as string).trim() !== "" && this.Value !== 'Invalid Date') ||
              i18n.t("main.operation.errors.rquiredField", {
                name: this.Declaration.Caption,
                msg: this.Declaration.CheckMsg
              })
          }
        );
      } else if (this.Declaration.Type == DeclarationPropertiesTypes.CardSelector) {
        if (this.Value && this.Value.Key) {
          rules.push(
            () =>
              this.Declaration.View != 0 ||
              (this.Value != null) ||
              i18n.t("main.operation.errors.rquiredField", {
                name: this.Declaration.Caption,
                msg: this.Declaration.CheckMsg
              })
          );
        } else {
          rules.push(
            () =>
              this.Declaration.View != 0 ||
              (this.Value && ((this.Value as string).trim() !== "")) ||
              i18n.t("main.operation.errors.rquiredField", {
                name: this.Declaration.Caption,
                msg: this.Declaration.CheckMsg
              })
          );
        }
      }
    }

    if (
      this.Declaration.ListType.trim() === "" &&
      this.Declaration.Type === DeclarationPropertiesTypes.String &&
      this.Declaration.Size
    ) {
      if(!this.IsPhone)
      rules.push(
        () =>
          this.Declaration.View != 0 ||
          this.Value == null ||
          this.Value.length <= this.Declaration.Size ||
          i18n.t("main.operation.errors.tooLongField", {
            name: this.Declaration.Caption,
            size: this.Declaration.Size
          })
      );
    }

    if (
      this.Declaration.Type == DeclarationPropertiesTypes.String &&
      this.Declaration.Check
    ) {
      if (this.IsPhone) {
        rules.push(() => {
          const regex: RegExp = new RegExp(this.SelectedPhoneFormat.СheckRegExp);
          return (
            this.Declaration.View != 0 || this.PhoneRightValue === '' ||
            regex.test(this.PhoneRightValue) ||
            i18n.t("main.operation.errors.invalidField", {
              name: this.Declaration.Caption,
              msg: this.Declaration.CheckMsg
            })
          );
        });
      } else {
        rules.push(() => {
          const regex: RegExp = new RegExp(this.Declaration.Check);
          return (
            this.Declaration.View != 0 || this.Value === '' ||
            regex.test(this.Value) ||
            i18n.t("main.operation.errors.invalidField", {
              name: this.Declaration.Caption,
              msg: this.Declaration.CheckMsg
            })
          );
        });
      }
    }

    this.CheckRules = rules;
  }
  /**
   * Загрузка списка вариантов.
   */
  public loadValues(contracts: ContractsModel | null = null): void {
    this.Values = [];

    if (
      this.Declaration.Type == DeclarationPropertiesTypes.UserAccount &&
      contracts != null
    ) {
      // Загрузка счетов.
      const accountsNoSorted: Array<ContractModel> = contracts.getContractsByFilter(
        this.Declaration.Filter as ContractsFilters
      );

      if (!accountsNoSorted.length) {
        throw new Error(
          i18n.t("main.operation.errors.noMatchingContracts").toString()
        );
      }

      const accounts = accountsNoSorted.sort((c1: ContractModel, c2: ContractModel) => { return this.acntComparer(c1, c2) });
      //.sort((c1: ContractModel, c2: ContractModel) => {
      //     if (c1.Data.ContractType > c2.Data.ContractType) {
      //       return -1;
      //     } else if (c1.Data.ContractType < c2.Data.ContractType) {
      //       return 1;
      //     } else if (
      //       c1.Data.DateOpen &&
      //       c2.Data.DateOpen &&
      //       c1.Data.DateOpen < c2.Data.DateOpen
      //     ) {
      //       return -1;
      //     } else if (
      //       c1.Data.DateOpen &&
      //       c2.Data.DateOpen &&
      //       c1.Data.DateOpen > c2.Data.DateOpen
      //     ) {
      //       return 1;
      //     } else if (!c1.Data.DateOpen && c2.Data.DateOpen) {
      //       return -1;
      //     } else if (c1.Data.DateOpen && !c2.Data.DateOpen) {
      //       return 1;
      //     } else {
      //       return 0;
      //     }
      //   });

      accounts.forEach((ac: ContractModel) => {
        if (this.Declaration.Name.toLowerCase() == "contract") {

          const contractAlias: string = ac.Data.Alias.trim() === "" ? ac.Data.MainAccount.substring(0, 5) : ac.Data.Alias;
          const restValue = this.getRestForOperation(this.Declaration, ac.Data);
          const contractLimit: string = `${sumFilter(restValue)} ${currencyFilter(ac.Data.CurrencyCharCode)}`;
          if (ac.Data.DisposableLimit > 0 || appConfig.emptyContractsInOpers) {

            this.Values.push(
              new DeclarationPropertyValueData(
                ac.Data.ReferenceId,
                this.getContractAliasByTemplate(contractAlias, contractLimit)
              )
            );

          }

        } else if (this.Declaration.Name.toLowerCase() == "contractto") {

          const contractAlias: string = ac.Data.Alias.trim() === "" ? ac.Data.MainAccount.substring(0, 5) + "*" + ac.Data.MainAccount.substring(16, 4) : ac.Data.Alias;
          const contractLimit: string = `${ac.Data.ContractType == ContractsTypes.CreditAccount ? ac.DepositSum : ac.DisposableLimit} ${currencyFilter(ac.Data.CurrencyCharCode)}`;
          this.Values.push(
            new DeclarationPropertyValueData(
              ac.Data.ReferenceId,
              this.getContractAliasByTemplate(contractAlias, contractLimit)
            )
          );

        } else {

          const contractAlias: string = ac.Data.Alias.trim() === "" ? ac.Data.MainAccount.substring(0, 5) : ac.Data.Alias;
          const contractLimit: string = `${ac.DisposableLimit} ${currencyFilter(ac.Data.CurrencyCharCode)}`;
          this.Values.push(
            new DeclarationPropertyValueData(
              ac.Data.ReferenceId,
              this.getContractAliasByTemplate(contractAlias, contractLimit)
            )
          );

        }
      });
      // } else if (this.Declaration.Type == DeclarationPropertiesTypes.CardSelector) {
      //    // Загрузка карт.
      //    const accountsNoSorted: Array<ContractModel> = (contracts as ContractsModel).getContractsByFilter(
      //       ContractsFilters.All
      //     );

      //   if (!accountsNoSorted.length) {
      //     return;
      //   }

      //   const accounts = accountsNoSorted
      //     .filter((x: ContractModel) => {
      //       return (
      //         x.Data.ContractType != ContractsTypes.CreditAccount
      //       );
      //     });

      //   accounts.forEach((ac: ContractModel) => {
      //     ac.Cards.forEach((c: CardModel) => {
      //       if(c.Data.CardState == CardsStates.Active) {
      //         const cardValue: string = `${c.CardPlasticTypeTitle} ${c.ShortCardNumber.substring(2)} - ${ac.DisposableLimit} ${ac.Currency}`;
      //         this.Values.push(new DeclarationPropertyValueData(c.Data.ReferenceId, cardValue));
      //       }
      //     });
      //   });
      //   this.Value = ""
    } else if (this.Declaration.Type == DeclarationPropertiesTypes.BankBik) {

      for (const key in this.Declaration.Values) {
        const val = this.Declaration.Values[key];
        const image = val.Image ? urlFilter(val.Image) : '';
        this.Values.push(
          new DeclarationPropertyValueData(val.Key, val.Key, image, null, val.Value, val.Id)
        );
      }
    } else if (this.Declaration.ListType.trim() !== "") {
      for (const key in this.Declaration.Values) {
        const val = this.Declaration.Values[key];
        const image = val.Image ? urlFilter(val.Image) : '';
        this.Values.push(
          new DeclarationPropertyValueData(val.Key, val.Value, image, null, '', val.Id)
        );
      }
    }

    if (this.Values.find((val: DeclarationPropertyValueData) => val.Id !== 0)) {
      this.sortValues();
    }
  }

  private sortValues(): void {
    this.Values.sort((a: DeclarationPropertyValueData, b: DeclarationPropertyValueData) => a.Id > b.Id ? 1 : -1);
  }

  /**
  * Отображаемый клиенту остаток в операции
  */
  public getRestForOperation(declaration: DeclarationPropertyData, contract: ContractData) {
    return this.defineContractRestForOperation(declaration, contract)
  }

  /**
  * Расчет отображаемого клиенту остатка в операции
  * На основе фильтра и DisplayRestModes.
  */
  private defineContractRestForOperation(declaration: DeclarationPropertyData, contract: ContractData) {
    let rc: number;
    // 0 - по умолчанию, 1 - DisposableLimit, 2 - Rest, 3 - DepositSum
    let dType = 0;
    if (declaration && declaration.DisplayRestModes && Array.isArray(declaration.DisplayRestModes) &&
      contract && typeof contract.ContractType === 'number' &&
      contract.ContractType > 0 && contract.ContractType < 6 &&
      declaration.DisplayRestModes.length >= contract.ContractType) {
      dType = declaration.DisplayRestModes[contract.ContractType - 1];
    }

    if (dType > 0 && dType < 4) {
      rc = dType == 1 ? (contract.DisposableLimit ?? 0) :
        dType == 2 ? (contract.Rest ?? 0) :
          (contract.DepositSum ?? 0);
    } else if (declaration.Name.toLowerCase() == "contractto") {
      rc = contract.DisposableLimit ?? 0;
    } else if (contract.ContractType == ContractsTypes.CreditAccount) {
      if (declaration.Filter == 6) {
        rc = contract.DepositSum ?? 0;
      } else {
        rc = contract.Rest ?? 0;
      }
    } else if (contract.ContractType == ContractsTypes.CardAccount) {
      rc = contract.DisposableLimit ?? 0;
    } else {
      rc = contract.Rest ?? 0;
    }

    return rc;
  }

  private getContractAliasByTemplate(alias: string, limit: string): string {
    const valTemplate: string = appConfig.contractsControllerLabelTemplate ?? "";
    return valTemplate.length ? replaceByTemplate({ Alias: alias, Limit: limit }, valTemplate) : `${alias} - ${limit}`
  }

  /**Проверка валидности свойства
   * @returns Результат проверк true - поле валидно иначе текст ошибки.
   */
  public check(): boolean | string {
    let checkResult: boolean = true;

    this.CheckRules.forEach((rule: any) => {
      const result = rule();
      if (result !== true) {
        checkResult = result;
        return;
      }
    });

    return checkResult;
  }
  /**
   * Получение текстового значения реквизита.
   * @returns Текстовое значение.
   */
  public getProperty(): string {
    let sValue: string = "";
    const parser = new DOMParser();
    if (
      (this.Declaration.ListType.trim() !== "" ||
        this.Declaration.Type === DeclarationPropertiesTypes.UserAccount)
      && this.Declaration.Type != DeclarationPropertiesTypes.CardSelector
    ) {
      const selectedValue = this.Value as DeclarationPropertyValueData;
      sValue = selectedValue ? selectedValue.Key : "";
    } else if (this.IsPhone) {
      sValue = `${this.SelectedPhoneFormat.DisplayCode}${this.PhoneRightValue.replace(/\s|\(|\)|\-/g, "")}`
    } else {
      switch (this.Declaration.Type) {
        case DeclarationPropertiesTypes.Int:
          sValue = this.Value;
          break;
        case DeclarationPropertiesTypes.Decimal:
          sValue =
            this.Value == null || this.Value.trim() === ""
              ? ""
              : this.Value.replace(/,/g, ".").replace(/\s+/g, "");
          break;
        case DeclarationPropertiesTypes.DateTime:
          sValue = this.Value;
          break; //yyyy-MM-dd hh:mm:ss
        case DeclarationPropertiesTypes.Boolean:
          sValue = this.Value;
          break;
        case DeclarationPropertiesTypes.CardSelector:
          sValue =
            this.Value == null
              ? ''
              : this.Value.Key ? this.Value.Key.trim().replace(/\s+/g, "") : this.Value.trim().replace(/\s+/g, "");
          break;
        case DeclarationPropertiesTypes.ObjectsList:
          sValue = this.Value ? this.Value : '';
          break;
        default:
          sValue = this.Value;
          break;
      }
    }
    return sValue;
  }

  /**
   * Установка значения реквизита.
   * @param sValue Значение.
   */
  public setProperty(sValue: string, operId: string = ''): void {
    if (
      this.Declaration.ListType.trim() !== "" ||
      this.Declaration.Type === DeclarationPropertiesTypes.UserAccount
    ) {
      this.setSelectedValue(sValue, operId);
    } else if (this.IsPhone && 
      (
        this.SelectedPhoneFormat.DisplayCode !== sValue.substring(0, this.SelectedPhoneFormat.DisplayCode.length) ||
        this.PhoneRightValue.trim() == ""
      )
    ) {
      this.Value = sValue;
      const phoneValue: string = sValue.replace("+", "");
      let selectedPhone: PhoneFormat | null = null;
      for (const format of this.PhoneFormats) {
        if (sValue.startsWith(format.DisplayCode)) {
          const withoutCode: string = sValue.substring(format.DisplayCode.length).trim();
          if (
            (!withoutCode || !withoutCode.length) ||
            (new RegExp(format.СheckRegExp).test(withoutCode) && format.Mask.length === withoutCode.length)
          ) {
            selectedPhone = format;
            break;
          }
        }
      }
      // const maxCodeCount = 3;
      // let codeCounter = 1;
      // do {
      //   selectedPhone = this.RawPhoneFormats[phoneValue.substring(0, codeCounter).padStart(maxCodeCount, "0")]
      //   if (selectedPhone) {
      //     break;
      //   }
      //   codeCounter++;
      // } while (codeCounter <= maxCodeCount)

      if (selectedPhone) {
        this.SelectedPhoneFormat = selectedPhone;
        this.PhoneRightValue = phoneValue.substring(selectedPhone.DisplayCode.length).replace(/\s|\(|\)|\-/g, "");
      } else {
        this.IsPhone = false;
      }
    } else {
      switch (this.Declaration.Type) {
        case DeclarationPropertiesTypes.Int:
          this.Value = sValue;
          break;
        case DeclarationPropertiesTypes.Decimal:
          this.Value =
            sValue == null || sValue.trim() === ""
              ? ""
              : sValue.replace(".", ","); //sValue.replace(",", ".");
          break;
        case DeclarationPropertiesTypes.DateTime: {
          this.Value = sValue.substring(0, 10);
          break;
        }
        case DeclarationPropertiesTypes.Boolean: {
          const slValue = sValue.toLowerCase();
          this.Value =
            sValue != null &&
            sValue.trim() !== "" &&
            (slValue == "1" || slValue == "true");
          break;
        }
        case DeclarationPropertiesTypes.Action:
          this.Value = "";
          break;
        default:
          this.Value = sValue;
          break;
      }
    }
  }

  /**
   * Установка выбранного варианта извне.
   * @param value Значение
   */
  private setSelectedValue(value: string, operId: string = ''): void {
    if (
      this.Value != null &&
      (this.Value as DeclarationPropertyValueData)?.Key === value
    )
      return;
    const declType: DeclarationPropertiesTypes = this.Declaration.Type;
    this.Values.forEach((val: DeclarationPropertyValueData) => {
      if (declType === DeclarationPropertiesTypes.CardSelector && operId === this.ToCardOperationId) {
        const arr: Array<string> = val.Key.split('|');
        if (arr[1] == value) {
          this.Value = val.Key;
          return;
        }
      } else {
        if (val.Key == value) {
          this.Value = val;
          return;
        }
      }
    });
    if (
      (declType == DeclarationPropertiesTypes.CardSelector && this.Value === null && operId === this.ToCardOperationId) || (!value)
    ) {
      this.Value = value;
    }
  }

  private acntComparer(x: ContractModel, y: ContractModel): number {
    if (x.Data.ContractType == ContractsTypes.CardAccount && y.Data.ContractType != ContractsTypes.CardAccount)
      return -1;

    if (y.Data.ContractType == ContractsTypes.CardAccount && x.Data.ContractType != ContractsTypes.CardAccount)
      return 1;

    if (x.Data.ContractType == ContractsTypes.CurrentAccount && y.Data.ContractType != ContractsTypes.CurrentAccount)
      return -1;

    if (y.Data.ContractType == ContractsTypes.CurrentAccount && x.Data.ContractType != ContractsTypes.CurrentAccount)
      return 1;

    if (x.Data.ContractType == ContractsTypes.TimeAccounts && y.Data.ContractType != ContractsTypes.TimeAccounts)
      return -1;

    if (y.Data.ContractType == ContractsTypes.TimeAccounts && x.Data.ContractType != ContractsTypes.TimeAccounts)
      return 1;

    if (x.Data.ContractType == ContractsTypes.CreditAccount && y.Data.ContractType != ContractsTypes.CreditAccount)
      return -1;

    if (y.Data.ContractType == ContractsTypes.CreditAccount && x.Data.ContractType != ContractsTypes.CreditAccount)
      return 1;

    if (x.Data.CurrencyCharCode == "RUR" && y.Data.CurrencyCharCode != "RUR")
      return -1;

    if (y.Data.CurrencyCharCode == "RUR" && x.Data.CurrencyCharCode != "RUR")
      return 1;

    if (x.Data.CurrencyCharCode == "EUR" && y.Data.CurrencyCharCode != "EUR")
      return -1;

    if (y.Data.CurrencyCharCode == "EUR" && x.Data.CurrencyCharCode != "EUR")
      return 1;

    if (x.Data.CurrencyCharCode == "USD" && y.Data.CurrencyCharCode != "USD")
      return -1;

    if (y.Data.CurrencyCharCode == "USD" && x.Data.CurrencyCharCode != "USD")
      return 1;

    if (x.Data.CurrencyCharCode == "GBP" && y.Data.CurrencyCharCode != "GBP")
      return -1;

    if (y.Data.CurrencyCharCode == "GBP" && x.Data.CurrencyCharCode != "GBP")
      return 1;

    if (x.Data.CurrencyCharCode == "CHF" && y.Data.CurrencyCharCode != "CHF")
      return -1;

    if (y.Data.CurrencyCharCode == "CHF" && x.Data.CurrencyCharCode != "CHF")
      return 1;

    if (!x.DateOpen && !y.DateOpen)
      return 0;

    if (!!x.DateOpen && !y.DateOpen)
      return -1;

    if (!!y.DateOpen && !x.DateOpen)
      return 1;

    if (x.DateOpen < y.DateOpen)
      return -1;

    if (y.DateOpen < x.DateOpen)
      return 1;

    return 0;
  }
}
